import {Card, theme, Typography} from 'antd';
import React from 'react';

interface IProps {
  item: any;
  toggleView?: any;
  handleItem?: any;
}

const GiftCard: React.FC<IProps> = (props) => {
  const {item, toggleView, handleItem} = props;
  const {token}: any = theme.useToken();
  const toggleAndHandle = () => {
    toggleView();
    handleItem(item);
  };

  return (
    <Card
      hoverable
      onClick={toggleAndHandle}
      style={{flex: '0 0 23%', borderColor: token.colorBorderSecondary}}
      styles={{
        body: {display: 'flex', flexDirection: 'column', gap: 10, width: '100%', padding: 16},
      }}
      cover={
        <img
          src={item.images[1].imageUrl}
          alt={item.images[1].altText}
          style={{
            height: 140,
            objectFit: 'cover',
            borderTopLeftRadius: token.borderRadiusLG,
            borderTopRightRadius: token.borderRadiusLG,
          }}
        />
      }>
      <Typography.Text strong style={{textAlign: 'center', alignSelf: 'center', fontSize: 13}}>
        {item.titleShort}
      </Typography.Text>
      <div style={{display: 'flex', flex: 1, justifyContent: 'center'}}>
        <img src={item.images[0].imageUrl} alt={item.images[0].altText} height="40" width="40" />
      </div>
    </Card>
  );
};

export default GiftCard;
